// Import des styles
import "./MemberCard.css"
import "./MemberCardResponsive.css"

// Import des composants
import Header from "../../components/Header/Header";
import Card from "../../components/Card/Card"


function MemberCard() {

    return (
        <>

            <Header/>
            <Card/>
            
        </>
    );
}

export default MemberCard;